module.exports = __webpack_public_path__ + "img/3.e0d45ee6.jpg";